window.runtimeConfig = {
  AFP_URL: "https://staging.airteam.cloud",
  AFP_SERVER_URL: "https://afp.staging.airteam.cloud",
  FFSOLAR_SERVER_URL: "https://staging.editor.airteam.cloud",
  STATIC_MODELS_URL:
    "https://storage.googleapis.com/airteam-rc-automation/media/files/26252/gltf_files/",
  APP_ENV: "staging",
  PRODUCT_FRUITS_WORKSPACE_CODE: "xthwjpIxi5IdQzpV",
  ZITADEL_ISSUER: "https://auth.staging.airteam.cloud",
  ZITADEL_CLIENT_ID: "325943478821388324",
};
